import * as React from "react";
import styled, { css } from "styled-components";
import { Menu } from "components/bootstrap";
import { Icon } from "components/common";
import { hoverIndicatorStyles } from "components/common/NavItemStateIndicator";
import usePermissions from "hooks/usePermissions";
import NavigationLink from "components/navigation/NavigationLink";
import shouldRenderNavigationItem from "components/navigation/util/shouldRenderNavigationItem";
import { NAV_ITEM_HEIGHT } from "theme/constants";
const BurgerToggle = styled.button(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    background: transparent;
    border: 0;
    padding: 0 15px;
    min-height: ${NAV_ITEM_HEIGHT};
    color: ${theme.colors.text.primary};

    &:hover,
    &:focus-visible {
      ${hoverIndicatorStyles(theme)}
    }
  `
);
const CollapsedMainNavbar = ({ navigationItems }) => {
  const { isPermitted } = usePermissions();
  const accessibleItems = navigationItems.filter(
    ({ requiredFeatureFlag, permissions }) => shouldRenderNavigationItem(requiredFeatureFlag, permissions, isPermitted)
  );
  return /* @__PURE__ */ React.createElement(Menu, null, /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(BurgerToggle, { type: "button", "aria-label": "Toggle navigation" }, /* @__PURE__ */ React.createElement(Icon, { name: "menu", size: "lg" }))), /* @__PURE__ */ React.createElement(Menu.Dropdown, null, accessibleItems.map(({ description, path, children, BadgeComponent }) => {
    if (!children) {
      return /* @__PURE__ */ React.createElement(NavigationLink, { key: description, description, path, Badge: BadgeComponent });
    }
    const accessibleChildren = children.filter(
      ({ requiredFeatureFlag, permissions, useCondition }) => {
        var _a;
        return (
          // eslint-disable-next-line react-hooks/rules-of-hooks
          ((_a = useCondition == null ? void 0 : useCondition()) != null ? _a : true) && shouldRenderNavigationItem(requiredFeatureFlag, permissions, isPermitted)
        );
      }
    );
    if (!accessibleChildren.length) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Menu.Sub, { key: description }, /* @__PURE__ */ React.createElement(Menu.Sub.Target, null, /* @__PURE__ */ React.createElement(Menu.Sub.Item, null, description)), /* @__PURE__ */ React.createElement(Menu.Sub.Dropdown, null, accessibleChildren.map((child) => /* @__PURE__ */ React.createElement(
      NavigationLink,
      {
        key: child.description,
        description: child.description,
        path: child.path,
        Badge: child.BadgeComponent
      }
    ))));
  })));
};
export default CollapsedMainNavbar;
